module.exports = __webpack_public_path__ + "img/Excel.b2b83128.svg";